<template>

  <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>TUV SUD</h1>
        <p></p>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <p>
      
      </p>
      
    </div>

  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'home',
  computed: {
        ...mapState('alert', ['status'])

    },
    data () {
        return {
          isci:'',
        }
      },
  created () {
       
       // this.success("test");
    },
      methods: {
        ...mapActions({clearAlert: 'alert/clear'}),
        ...mapActions({errorAlert: 'alert/error'}),
       
        handleSubmit(e){

          e.preventDefault();
        },
        isciCertifikat(e){
          this.clearAlert();
          if(!this.isci) {
              this.errorAlert("Vnesti morate iskalni niz!")
              return;
              }
          if(this.isci.length<3) {
              this.errorAlert("Iskalni niz mora biti dolg vsaj 3 znake")
              return;
              }
          
           this.$router.push({ name: 'certifikatiJavno', params: { isci: this.isci } })
        

        }
    }
}


</script>

<style>
h1{
  color:white;
}
#isci {
  max-width:500px
}
</style>